export const personasArray = [{
    slug: 'organogram',
    name: {
      en: 'Organogram',
      pt: 'Organograma',
    }
  },    
  {
    slug: 'persona',
    name: {
      en: 'Position/Function',
      pt: 'Cargo/Função',
    }
  }
]

export const seniorityArray: any = [
    {
      slug: 'specialist',
      name: {
        en: 'Specialist',
        pt: 'Especialista',
      }
    },
    {
      slug: 'senior',
      name: {
        en: 'Senior',
        pt: 'Sênior',
      }
    },
    {
      slug: 'mid',
      name: {
        en: 'Mid-level',
        pt: 'Pleno',
      }
    },
    {
      slug: 'junior',
      name: {
        en: 'Junior',
        pt: 'Junior',
      }
    },
];